export const BASE_URL = process.env.BASE_URL;
export const CONFIG_URL = process.env.CONFIG_URL;
export const SHARED_CONFIG= process.env.SHARED_CONFIG;
export const WS_URL = process.env.WS_URL;
export const VERSION = process.env.VERSION;
